module.exports = __webpack_public_path__ + "static/media/delete.d9b70cbe.svg";